import { api } from '@/lib/api/api'
import {
  AdMetricsTimeseriesRequest,
  AdMetricsTimeseriesResponse,
  AdPlatform,
  TimeGranularity,
} from 'sprites-types/api/v2'

type AdMetricsTimeseriesApiResponse = {
  success: boolean
  data?: AdMetricsTimeseriesResponse
  error?: string
}

type AccountMetricsTimeseriesRequest = {
  platform: AdPlatform
  metric: string
  startDate: string
  endDate: string
  granularity: TimeGranularity
}

export const adMetricsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAdMetricsTimeseries: builder.query<AdMetricsTimeseriesResponse, AdMetricsTimeseriesRequest>({
      query: (params) => ({
        url: 'v2/ad-metrics/timeseries',
        params,
      }),
      transformResponse: (response: AdMetricsTimeseriesApiResponse) => {
        if (!response.success || !response.data) {
          throw new Error(response.error || 'Failed to fetch ad metrics timeseries')
        }
        return response.data
      },
      providesTags: (_result, _error, { entityId, entityType, platform, metric, granularity }) => [
        {
          type: 'AdMetricsTimeseries',
          id: `${platform}-${entityType}-${entityId}-${metric}-${granularity}`,
        },
      ],
      keepUnusedDataFor: 300,
    }),
    getAccountMetricsTimeseries: builder.query<
      AdMetricsTimeseriesResponse,
      AccountMetricsTimeseriesRequest
    >({
      query: (params) => ({
        url: 'v2/ad-metrics/account-timeseries',
        params,
      }),
      transformResponse: (response: AdMetricsTimeseriesApiResponse) => {
        if (!response.success || !response.data) {
          throw new Error(response.error || 'Failed to fetch account metrics timeseries')
        }
        return response.data
      },
      providesTags: (_result, _error, { platform, metric, granularity }) => [
        {
          type: 'AdMetricsTimeseries',
          id: `${platform}-account-${metric}-${granularity}`,
        },
      ],
      keepUnusedDataFor: 300,
    }),
  }),
})

export const {
  useGetAdMetricsTimeseriesQuery,
  useLazyGetAdMetricsTimeseriesQuery,
  useGetAccountMetricsTimeseriesQuery,
  useLazyGetAccountMetricsTimeseriesQuery,
} = adMetricsApi
